import React from "react";

import { templates } from "@reactivated";

import { DynamicPrice } from "../apps/price/DynamicPrice";
import { IProduct } from "../models/catalogue";

export const Template = (
    props: templates.DynamicPriceTemplate,
): React.JSX.Element | null => {
    if (!props.product) {
        return null;
    }
    const product: IProduct = JSON.parse(props.product);
    return <DynamicPrice productPrice={product.price} />;
};
